<ion-header [hidden]="global.scanCamera">
  <ion-toolbar>
    <ion-title>{{tableDescr}} {{ i18n.tr('invoer') }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [hidden]="global.scanCamera">
  <table class="record-table">
    <colgroup>
    <col style="width: 90px" />
    <!-- ? label column -->
    <col />
    <!-- ? input column -->
  </colgroup>
  @for (q of recordFields; track customTrackBy(i, q); let i = $index) {
    <tr>
      @if (q.typ!=='-') {
        <td class="tag">{{q.descr}}</td>
      }
      <td>
        @if (q.typ=='C') {
          <mat-checkbox
            [(ngModel)]="recordFields[i].value"
            (ngModelChange)="evalForm()"
            >
          </mat-checkbox>
        }
        @if (q.typ=='COMBO') {
          <mat-form-field>
            <input
              matInput
              [matAutocomplete]="auto"
              [(ngModel)]="recordFields[i].value"
              (ngModelChange)="comboChanged($event, i); evalForm()"
              [ngClass]="{'invalid': !q.valid}"
              [disabled]="!recordFields[i].EditCond"
              />
            <mat-autocomplete
              #auto="matAutocomplete"
              panelWidth="400px"
              (optionSelected)="comboChanged($event.option.value, i)"
              >
              @for (lst of recordFields[i].choices; track lst) {
                <mat-option
                  [value]="lst.ID"
                  >
                  <span>{{lst.ID}}: {{lst.txt}}</span>
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        }
        @if (q.typ=='D') {
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="picker2"
              [min]="recordFields[i].minDate"
              [(ngModel)]="recordFields[i].value"
              [disabled]="!recordFields[i].EditCond"
              (ngModelChange)="evalForm()"
              />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker2"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
        }
        @if (q.typ=='HTML') {
          <div class="html-editor-container">
            <quill-editor
              class="quill-editor-field"
              [(ngModel)]="recordFields[i].value"
              [modules]="quillConfig"
              [readOnly]="!recordFields[i].EditCond"
              (onContentChanged)="evalForm()"
              >
            </quill-editor>
            <ion-button
              class="voice-memo-button"
              fill="clear"
              (click)="openVoiceMemoModal(i)"
              [disabled]="!recordFields[i].EditCond"
              >
              <ion-icon
                name="mic-outline"
                slot="icon-only"
              ></ion-icon>
            </ion-button>
          </div>
        }
        @if (q.typ=='L') {
          <mat-form-field>
            <mat-select
              [(value)]="recordFields[i].value"
              (selectionChange)="evalForm()"
              [disabled]="!recordFields[i].EditCond"
              >
              @for (lst of recordFields[i].choices; track lst) {
                <mat-option
                  [value]="lst.ID"
                  >
                  {{lst.txt}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (q.typ=='N') {
          <mat-form-field>
            <input
              type="number"
              matInput
              [(ngModel)]="recordFields[i].value"
              (ngModelChange)="evalForm()"
              [disabled]="!recordFields[i].EditCond"
              />
          </mat-form-field>
        }
        @if (q.typ=='R') {
          <mat-form-field>
            <input
              matInput
              [(ngModel)]="recordFields[i].value"
              (ngModelChange)="evalForm()"
              [disabled]="!recordFields[i].EditCond"
              />
            @if (q.msg) {
              <mat-error>{{q.msg}}</mat-error>
            }
          </mat-form-field>
        }
        @if (q.typ=='T') {
          <mat-form-field>
            <textarea
              matInput
              rows="5"
              [(ngModel)]="recordFields[i].value"
              [disabled]="!recordFields[i].EditCond"
            ></textarea>
          </mat-form-field>
        }
        @if (q.typ=='TIME') {
          <mat-form-field>
            <input
              #timeInput
              type="time"
              step="60"
              matInput
              [(ngModel)]="recordFields[i].value"
              (click)="openTimePicker(timeInput)"
              (ngModelChange)="evalForm()"
              [disabled]="!recordFields[i].EditCond"
            />
            @if (q.msg) {
              <mat-error>{{q.msg}}</mat-error>
            }
          </mat-form-field>
        }
        @if (!global.optHideScanBtn && q.btn=='SCAN') {
          <ion-button
            size="small"
            (click)="doScan(i)"
            >
            <ion-icon name="barcode"></ion-icon>
          </ion-button>
        }
        @if (q.msg) {
          <span class="invalid"><br />{{q.msg}}</span>
        }
      </td>
    </tr>
  }
</table>
</ion-content>
<ion-footer [hidden]="global.scanCamera">
  <ion-toolbar>
    <ion-buttons slot="end" class="form-actions">
      <ion-button (click)="doCancel()" fill="clear">
        <ion-icon name="close-circle"></ion-icon>&nbsp;{{ i18n.tr('[en]Cancel') }}
      </ion-button>
      <ion-button (click)="doSubmit()" [disabled]="!formValid" fill="solid">
        <ion-icon name="checkmark-outline"></ion-icon>&nbsp;{{ i18n.tr('OK') }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
